/*
 * Ensure the store-specific Ordersify widget is available for collection-card
 * triggers. The app embed remains supported: when it has already emitted the
 * widget script, this loader deliberately does nothing.
 */
(function () {
  'use strict';

  const widgetPath = 'app.backinstock.org/widget/15600_1675165544.js';
  const loaderScript = document.currentScript;
  const loadOnScroll = loaderScript?.dataset.loadOnScroll === 'true';

  function widgetScriptExists() {
    return Array.from(document.scripts).some((script) => {
      return /(?:app\.backinstock\.org|backinstock\.useamp\.com)\/widget\/15600_/.test(script.src);
    });
  }

  function loadWidget() {
    if (widgetScriptExists() || document.querySelector('#BIS_frame')) {
      return;
    }

    const script = document.createElement('script');
    script.src = `https://${widgetPath}`;
    script.async = true;
    script.dataset.friendsBackInStock = 'true';
    document.head.appendChild(script);
  }

  function loadWhenReady() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', loadWidget, { once: true });
    } else {
      loadWidget();
    }
  }

  if (loadOnScroll && window.scrollY === 0) {
    window.addEventListener('scroll', loadWhenReady, { once: true, passive: true });
    return;
  }

  loadWhenReady();
})();
